import { useState, useEffect } from 'react';
import { getCurrentVersions, CurrentVersionsResponse } from '../utils/legalApi';

export function useLegalDocuments() {
  const [data, setData] = useState<CurrentVersionsResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    getCurrentVersions()
      .then(d => { setData(d); setLoading(false); })
      .catch(() => { setError(true); setLoading(false); });
  }, []);

  return { data, loading, error };
}
